import MarkdownRenderer from './markdown-renderer';
import NovartisContactFormButton from '../chat/novartis-contact-form-button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';

interface GenericModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: string;
  userQuery?: string;
}

function GenericModal(props: GenericModalProps) {
  return (
    <Dialog open={props.open} onOpenChange={props.onOpenChange}>
      <DialogContent className="sm:max-w-[480px] max-h-[450px] overflow-y-auto rounded-md">
        <DialogHeader>
          <DialogTitle className="mt-3 sm:mt-0 sm:mb-3 text-left">{props.title}</DialogTitle>
          <DialogDescription className="sr-only">{props.title}</DialogDescription>
        </DialogHeader>
        <MarkdownRenderer content={props.description} />
        <NovartisContactFormButton
          align="center"
          onLiveChatStart={() => props.onOpenChange(false)}
          query={props.userQuery}
        />
      </DialogContent>
    </Dialog>
  );
}

export default GenericModal;
